import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { CartServiceService } from '../../../_services/dashboardservice/cart/cart-service.service';
import { currentcartdetail } from '../../../models/dashboard/cart/mywallet.currentcart.Modal';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
import { PaymentreceiptService } from '../../../_services/paymentreceipt/paymentreceipt.service';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { PaymentReceiptDebitcardindividualPopupComponent } from '../../shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-individual-popup/payment-receipt-debitcard-individual-popup.component';
@Component({
  selector: 'app-payment-receipt-container-debitcard',
  templateUrl: './payment-receipt-container-debitcard.component.html',
  styleUrls: ['./payment-receipt-container-debitcard.component.css'],
  providers: [CartServiceService, Modal]
})
export class PaymentReceiptContainerDebitcardComponent implements OnInit {
  mobileScreen = false;
  showBothScreen = false;
  constructor( 
    private cartservice: CartServiceService,
    public utilserv: utilityService,
    private sendMoneyService: SendMoneyService,
    private paymentreceipt: PaymentreceiptService,
    public modal: Modal,
    private vcRef: ViewContainerRef
  ) {}
  ValidateMobileScreen(screen) {
    this.showBothScreen = screen.showBothScreen;
    this.mobileScreen = screen.mobileScreen;
  }
  ngOnInit() {
    // Call Cart Service
    const curcarddetailresponsemodel = new currentcartdetail();
    this.getcarttype(curcarddetailresponsemodel);
    const callSetStore = this.paymentreceipt.geIndivisualtRepeatorderData().subscribe(data => {
      if (callSetStore != undefined) {
        // callSetStore.unsubscribe();
        //    this.showBothScreen = true;
        // this.mobileScreen = true;
      }
    });
  }

  getcarttype(curcarddetailresponsemodel: currentcartdetail) {
    this.cartservice.getcarttypeservice().subscribe(data => {
      if (data.StatusCode == 20001) {
        return false;
      }
      if (data.StatusCode == enumStatusCodeList.SUCCESS) {
        curcarddetailresponsemodel.CartExpiry = this.utilserv.getObjectText(data.CartExpiry);
        curcarddetailresponsemodel.CustmerPaymentMethod = this.utilserv.getObjectText(data.CustmerPaymentMethod);
        // CustmerPaymentMethod-10,30 30-Debit card 10- Store
        curcarddetailresponsemodel.FundingId = this.utilserv.getObjectText(data.FundingId);
        curcarddetailresponsemodel.GuaranteedCancellationPeriod = this.utilserv.getObjectText(data.GuaranteedCancellationPeriod);
        curcarddetailresponsemodel.ItemCount = this.utilserv.getObjectText(data.ItemCount);
        curcarddetailresponsemodel.StoreId = this.utilserv.getObjectText(data.StoreId);
        curcarddetailresponsemodel.StoreName = this.utilserv.getObjectText(data.StoreName);
        curcarddetailresponsemodel.SuperSend = this.utilserv.getObjectText(data.SuperSend);
        curcarddetailresponsemodel.UnReadMessageCount = this.utilserv.getObjectText(data.UnReadMessageCount);

        this.cartservice.setcurrentcartDetailDashBoardData(curcarddetailresponsemodel);
        this.sendMoneyService.setcurrentcartDetailData(curcarddetailresponsemodel);

        // this.userDetails();
      }
    });
  }
  paymentReceiptClick() {
    if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
      const parent = this;

      this.modal.overlay.defaultViewContainer = this.vcRef;
      return this.modal.open(PaymentReceiptDebitcardindividualPopupComponent, overlayConfigFactory({ orderID: true }, BSModalContext)).then(function(obj) {
        obj.onDestroy.subscribe(data => {
          // let x = parent;
          // parent.ngOnInit();
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-debitcard/payment-receipt-container-debitcard.component.ts